module.exports = __webpack_public_path__ + "img/ic_chevron_right.7162351e.svg";